var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SiteSection',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.visibilityChanged,
    once: true,
    intersection: {
      threshold: 0.3,
    },
  }),expression:"{\n    callback: visibilityChanged,\n    once: true,\n    intersection: {\n      threshold: 0.3,\n    },\n  }"}],scopedSlots:_vm._u([{key:"background",fn:function(){return [_c('BaseBox',{staticClass:"absolute w-full h-full inset-0 bg-gray-100"})]},proxy:true},{key:"default",fn:function(){return [_c('BaseBox',{staticClass:"grid gap-12"},[_c('SiteHeading',[_c('i18n',{attrs:{"tag":false,"path":"title"}})],1),_c('TimeLine',{attrs:{"events":_vm.timelineEvents}})],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }